export {
  default,
  ILLUSTRATION_NAMES,
  Illustration,
  type IllustrationName,
  illustrationOf,
  isIllustrationName,
} from './Illustration'
